import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as PR from "../../../prime-modules/index";
import "./TopupEsims.scss";
import { getCatalogsList, getCountriesList } from "../../../services/api";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { track } from "@plausible-analytics/tracker";
import { cartFilterActions } from "../../../store/cart";
import { getDayLabel, geteSIMsDescription, formatCurrency, setDataAmount, setNumberPrecision } from "../../../utils/reuse";
import EsimStatusHeader from "./EsimStatusHeader";
import MakePayment from "../../../components/payment/MakePayment";
import { comingsoon } from "../../../assets/images";
import { renderRegionalCountryImage } from "../../../assets/images/eSIMCrewCountryImages/eSIMCrewImages";
import { flag } from "country-emoji";
import { useToast } from "../../../context/ToastContext";

const TopupEsims = (props) => {
  const dispatch = useDispatch();
  const { showToast, labels } = useToast();
  const getCartData = useSelector((state) => state.cart.catalogCart);
  const iccid = useSelector(state => state.esim.esimIccid);
  const isAuth = useSelector(state => state.auth.isLoggedIn);
  const navigate = useNavigate();
  const { state, pathname } = useLocation();
  const affiliateTrackingData = useSelector(state => state.affiliateTracking.affiliateTrackingInfo);
  const headers = useMemo(() => {
    return { afid: affiliateTrackingData };
  }, [affiliateTrackingData]);
  const [loading, setLoading] = useState(false);
  const [countryVal, setCountryVal] = useState(true);
  const [country, setCountry] = useState("");
  const [countries, setCountries] = useState([]);
  const [catalogs, setCatalogs] = useState([]);
  const [direction, setDirection] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [doNotSell, setDoNotSell] = useState(false)
  const filter = '';
  const filterBy = '';
  const page = '';
  const limit = '';
  const [checkoutFormState, setCheckoutFormState] = useState(false)
  const trackCountry = useCallback((countryName) => {
    track(
      'country', { props: { country: countryName } }
    );
  }, [])

  const clearStoreContent = useCallback(() => {
    dispatch(cartFilterActions.deleteCatalogCart());
    dispatch(cartFilterActions.setCatalogCartAmount(0));
  }, [dispatch])

  const getCountryData = useCallback(() => {
      const getResponse = (response) => {
        if (response.result === "SUCCESS") {
           
          if (response.data.length > 0) {
            const countriesList = response.data.map((c) => ({
              name: c.name.split("(")[0]?.trim(),
              region: c.region,
              iso: c.iso,
            }));
            setCountries(countriesList);
            setCountry(countriesList[0]?.iso)

            trackCountry(countriesList[0]?.name);
            setDirection(1);
            setOrderBy('price');
          } else {
          
            showToast("info", "ESMBND-03");
          }
        } else {
          const error = response.error;
          showToast(error.severity, error.errorMsg);
        }
      };
      const getIccid = (isAuth && iccid) ? '?iccid=' + iccid : '';
      const url = 'countries' + getIccid;
      getCountriesList(url, headers, dispatch, getResponse)
  }, [isAuth, iccid, headers, dispatch, trackCountry,showToast]);

  const getCatalogs = useCallback(() => {
    if (countryVal) {
      const getCatalogList = (response) => {
        if (response.result === "SUCCESS") {
          const catalogList = response.data && response.data.bundles ? response.data.bundles : [];
          setDoNotSell(iccid ? false : response?.data?.doNotSell)
          if (catalogList.length > 0) {
            let sortedCatalogs = catalogList.sort((a, b) => a.price - b.price)
            
            const limitedDataPlans = sortedCatalogs
              ?.filter((d) => d?.dataAmount !== -1)
              ?.sort((a, b) => a?.dataAmount - b?.dataAmount);
            const unlimitedDataPlans = sortedCatalogs
              ?.filter((d) => d?.dataAmount === -1)
              ?.sort((a, b) => a?.duration - b?.duration);
              sortedCatalogs = [...limitedDataPlans, ...unlimitedDataPlans];

            sortedCatalogs = sortedCatalogs.map(s => {
              s.description = geteSIMsDescription(s);
              return s;
            })
            setCatalogs(sortedCatalogs);
          } else {
        
            showToast("info", "ESMBND-04");
          }
        } else {
          const error = response.error;
          showToast(error.severity, error.errorMsg);
        }
        setLoading(false);
      }
      if (country && country !== '') {
        setLoading(true);
        setCatalogs([]);
        const catalogDirection = (direction === 1) ? 'asc' : 'desc';
        const catalogCountry = encodeURIComponent(country);
        const getIccid = (isAuth && iccid) ? '&iccid=' + iccid : '';
        const queryParameters = 'countries=' + catalogCountry + '&page=' + page + '&limit=' + limit + '&direction=' + catalogDirection + '&orderBy=' + orderBy + '&filter=' + filter + '&filterBy=' + filterBy + getIccid;
        getCatalogsList(queryParameters, headers, dispatch, getCatalogList)
      }
    }
  }, [countryVal, country, direction, isAuth, iccid, orderBy, headers, dispatch, showToast])

  useEffect(() => {
    getCountryData()
  }, [getCountryData])

  useEffect(() => {
    getCatalogs()
  }, [getCatalogs])

  const renderValidFor = (rowData) => rowData?.duration ? rowData?.duration + " " + getDayLabel(rowData?.duration, labels) : "-"

  const onCountryChange = (e) => {
    setCountryVal(false);
    setCountry(e.value);
  };

  const onCountryHide = (e) => {
      clearStoreContent();
      const getFilteredCountry = countries?.find(x => x.iso === country);
      trackCountry(getFilteredCountry?.name);
      setCountryVal(true);
  }

  const catalogPurchase = (catalogData) => {
    const catalogName = catalogData.name;
    const catalogPrice = setNumberPrecision(catalogData.price);

    const getCartObj = { ...getCartData };

    if (getCartObj !== catalogName) {
      const setCartData = {
        name: catalogName,
        description: catalogData.description,
        quantity: 1,
        price: +catalogPrice,
        speed: catalogData.speed,
        duration: catalogData.duration,
        dataAmount: catalogData.dataAmount,
        dataAmountForDisplay: catalogData.dataAmountForDisplay
      };
      dispatch(cartFilterActions.setCatalogCart(setCartData));
      dispatch(cartFilterActions.setCatalogCartAmount(+catalogPrice));
    }

    setCheckoutFormState(true);
  }

  const actions = (rowData) => {
    return (
      <PR.Button
        label="Top-up"
        disabled={doNotSell}
        className="action-btn"
        onClick={() => {
          setCheckoutFormState(true);
          catalogPurchase(rowData);
          navigate(pathname, {replace:true, state: {...state, affiliatePromoCodeCall:false}});
        }}
      />
    );
  };

  const priceBody = rowData => {
    return formatCurrency(rowData?.priceCurrency, rowData.price)
  }

  const dataAmountBody = rowData => {
    return setDataAmount(rowData, labels);
  }
 
  const dropdownCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          {
            renderRegionalCountryImage(option.iso)
              ? <div className="country-image">
                <img alt={option.iso} src={renderRegionalCountryImage(option.iso)} className="flag-img" />
              </div>
              : <div className="country-image">
                <div className="flag">
                  {
                    flag(option.iso)
                  }
                </div>
              </div>
          }

          <div>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
};

  return (
    <>
      <PR.Dialog className="forms-dialog payment-dialog" blockScroll={true} draggable={false} style={{ width: '75%' }} visible={checkoutFormState} onHide={() => setCheckoutFormState(false)} resizable={false}>
        <MakePayment setCheckoutFormState={setCheckoutFormState} setDisplayScreen={props.setDisplayScreen} />
      </PR.Dialog>
      <section className="esims-section">
        <div className="grid header-text">
          <div className="col-12">
            <div >
              <div className="search-box">
                <div className="grid align-items-center">
                  <div className="col-12 lg:col-6 md:col-6">
                    <h2>{labels.LBL0159}</h2>
                  </div>
                  <div className="col-12 lg:col-6 md:col-6 text-left md:text-right lg:text-right">
                    <form autoComplete="off">
                      <span className="p-input-icon-left search-field">
                        <i className="pi pi-search" />
                        <PR.Dropdown
                          filter
                          value={country}
                          options={countries}
                          onChange={(e) => onCountryChange(e)}
                          onHide={(e) => onCountryHide(e)}
                          resetFilterOnHide
                          optionLabel="name"
                          optionValue="iso"
                          placeholder={labels.LBL0160}
                          valueTemplate={dropdownCountryTemplate}
                          itemTemplate={dropdownCountryTemplate}
                        />
                      </span>
                    </form>
                  </div>
                  <EsimStatusHeader />
                </div>
              </div>
              { doNotSell && <p className='text-xs err-msg  mb-5'><sup className='err-msg'>*</sup> {labels?.LBL0171}</p>}
              <div className="card">
                <div className="topup-table">
                  {catalogs.length > 0 ? <PR.DataTable value={catalogs} loading={loading}>
                    <PR.Column field="description" header={labels.LBL0161} className="first-column"></PR.Column>
                    <PR.Column body={priceBody} header={labels.LBL0097}></PR.Column>
                    <PR.Column field={dataAmountBody} header={labels.LBL0024}></PR.Column>
                    <PR.Column body={renderValidFor} header={labels.LBL0162}></PR.Column>
                    <PR.Column body={actions} header={labels.LBL0163}></PR.Column>
                  </PR.DataTable>
                    :
                    <PR.Image src={comingsoon} alt={labels.LBL0164} width="100%" />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TopupEsims;